import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentComerciantes } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HistorialService {
    constructor(private http: HttpClient) { }

    getHistorialContratosByUserId(id: any) {
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Contract/GetByUserId?id=${id}`);
    }

    getRoutePDFContrato(){
        return `${environmentComerciantes.apiUrl}/Adobe/GetContract?name=`
    }

    getEvaluationByUserID(id: any){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Evaluation/GetUserId?id=${id}`);
    }

    getUrlFile(){
        return `${environmentComerciantes.urlFile}`
    }

   /* post(food: Food) {
        return this.http.post<Food>(`${environment.apiUrl}/FOOD/InsertOrUpdate`, food);
    }*/

}
